import { Component, inject } from '@angular/core';
import { SharedModule } from 'app/shared';
import { OverlayRef } from 'app/shared/ui/overlays/overlay-ref.model';
import { AuthApi } from './auth-api.service';
import { AuthService } from './auth.service';


@Component({
    selector: 'logout-modal',
    imports: [
        SharedModule,
    ],
    template: `
        <ui-modal>
            <modal-header [type]="loggedInWithCrea ? 'warning' : 'info'">
                {{ loggedInWithCrea ? 'Please Log out from the Board' : 'Logged Out' }}
            </modal-header>
            <modal-body>
                {{
                    loggedInWithCrea
                        ? 'You have been successfully logged out of AUTOPROP, to log out from the board, please click on the button below.'
                        : 'You have been successfully logged out'
                }}
            </modal-body>
            <modal-footer>
                @if (loggedInWithCrea) {
                    <a [href]="creaLogoutLink" class="btn btn-warning" autofocus>
                        Log Out from Board
                    </a>
                }
                @else {
                    <button
                        type="button"
                        class="btn btn-secondary"
                        (click)="close()">
                        Close
                    </button>
                }
            </modal-footer>
        </ui-modal>
    `,
})
export class LogoutModalComponent {

    private authService = inject(AuthService);

    loggedInWithCrea = this.authService.loggedInWithCrea;

    private authApi = inject(AuthApi);

    creaLogoutLink = this.authApi.getCreaLogoutLink();

    private overlayRef = inject(OverlayRef);

    close() {
        this.overlayRef.dismiss('close');
    }
}
